import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { SignupV2Service } from '../signup-v2.service';

/**
 * Route guard to prevent backward navigation after account creation
 *
 * If the account has been created (after completing step 2 - Personal Information),
 * users cannot navigate back to earlier steps (farmbox, delivery, personal).
 * They can only proceed to or remain on the payment step.
 */
export const signupNavigationGuard: CanActivateFn = (route, state) => {
  const signupService = inject(SignupV2Service);
  const router = inject(Router);

  // If account was created and trying to access earlier steps, redirect to payment
  if (signupService.isAccountCreated()) {
    const currentPath = state.url;

    // Allow payment step
    if (currentPath.includes('/signup/payment')) {
      return true;
    }

    // Block earlier steps - redirect to payment
    if (currentPath.includes('/signup/farmbox') ||
        currentPath.includes('/signup/delivery') ||
        currentPath.includes('/signup/personal')) {
      router.navigate(['/signup/payment']);
      return false;
    }
  }

  return true;
};
